const navigationDrawer = {
    init() {
        const x = window.matchMedia('(max-width: 1200px)');
        const body = $('body');
        const hamburger = $('.hamburger');

        $(document).on('click', '.hamburger', (e) => {
            $(e.currentTarget).toggleClass('is-active');
            body.toggleClass('drawer-open');
        });

        $(window).resize(() => {
            if (!x.matches) {
                body.removeClass('drawer-open');
                hamburger.removeClass('is-active');
            }
        });
    },
};

export default navigationDrawer;
